import configureSentry from '%app/js/common/services/configure-sentry';

configureSentry();
